import { PlatformID } from '@cms/common/clients/api/types.gen';
import { RateLimiter } from 'limiter';

export const missingKeyLogger = async ({ ns, key }: { ns: string; key: string }) => {
    if (!process || process.env['NODE_ENV'] === 'production') {
        return;
    }

    if (hasPlatformPrefix(key)) {
        // Do not create a translation key if the key contains the PlatformID as a prefix.
        return;
    }

    console.warn(`Missing translation key: ${key}`);

    if (!key) {
        console.warn(`[i18n] The text "${ns}" has no namespace in front of it.`);
        return;
    }

    if (/[A-Z]/g.test(ns)) {
        console.warn(`[i18n] Your "${ns}" contains a uppercase character, please change to dashed-case.`);
        return;
    }

    if (process && process.env?.LOKALISE_API_KEY) {
        await tryCreatingMissingKey(ns, key);
    }

    console.warn(
        `[i18n] "${ns}:${key}" is missing in current namespace configuration. Please add "${key}" to the namespace "${ns}".`,
    );
};

let rateLimiter: RateLimiter | undefined;

const tryCreatingMissingKey = async (ns: string, key: string) => {
    console.info(`[i18n] Trying to fetch "${key}" from Lokalise to add to "${ns}".`);

    const data = {
        file: ns,
        key: key,
    };

    if (!rateLimiter) {
        rateLimiter = new RateLimiter({ tokensPerInterval: 1, interval: 'second' });
    }

    try {
        await rateLimiter.removeTokens(1);
        const response = await fetch(process.env.NEXT_SERVER_API_HOST_LOCAL_VP + '/lokalise/key', {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json',
            },
        });

        if (!response.ok) {
            throw new Error('Failed to create missing key');
        }

        const result = await response.json();

        console.warn(`[i18n] result:`, result);
    } catch (error) {
        console.error(`[i18n] error:`, error);
    }
};

const hasPlatformPrefix = (key: string) => {
    const platformIDs: string[] = Object.values(PlatformID);
    const prefix = key.split('.')[0] || '';

    return platformIDs.includes(prefix);
};
